import { render, staticRenderFns } from "./IRAgmPage.vue?vue&type=template&id=41b14018"
import script from "./IRAgmPage.vue?vue&type=script&lang=js"
export * from "./IRAgmPage.vue?vue&type=script&lang=js"
import style0 from "./IRAgmPage.vue?vue&type=style&index=0&id=41b14018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports